import React from "react";
import { Link } from "react-router-dom";
import usePageMeta from "@/lib/usePageMeta";
import { Button } from "@/components/ui/button";
import { MapPin, ArrowRight } from "@phosphor-icons/react";

// Towns within ~60 km of Albury/Wodonga (NSW + VIC)
const locations = [
  // Inner Albury/Wodonga + suburbs
  "Albury", "Wodonga", "Lavington", "Thurgoona", "West Albury", "East Albury",
  "North Albury", "South Albury", "Glenroy", "Springdale Heights", "Hamilton Valley",
  "Table Top", "Splitters Creek", "Ettamogah",
  "West Wodonga", "Bonegilla", "Bandiana", "Killara", "Baranduda", "Leneva",
  "Wodonga West",
  // NSW within 60 km
  "Jindera", "Howlong", "Walbundrie", "Burrumbuttock", "Gerogery", "Brocklesby",
  "Walla Walla", "Culcairn", "Holbrook", "Henty",
  // VIC within 60 km
  "Yackandandah", "Tallangatta", "Tangambalanga", "Kiewa", "Bethanga",
  "Chiltern", "Barnawartha", "Wahgunyah", "Rutherglen", "Springhurst",
  "Beechworth", "Stanley", "Allans Flat", "Osbornes Flat", "Indigo Valley",
  "Mount Beauty (outer)", "Mitta Mitta (outer)",
];

export default function Locations() {
  usePageMeta({ title: "Service Area", path: "/locations", description: "Maintenance & handyman services across 40+ towns within 60km of Albury and Wodonga — NSW and VIC sides of the border." });
  return (
    <div data-testid="locations-page">
      <section data-nav-theme="dark" className="bg-navy-deep text-white py-20 min-h-[60vh] flex items-center">
        <div className="max-w-7xl mx-auto px-5 md:px-8 w-full">
          <div className="eyebrow">Where we work</div>
          <h1 className="font-display display-lg tracking-wide mt-3 leading-tight">Servicing within 60 km of Albury &amp; Wodonga.</h1>
          <p className="mt-4 text-slate-300 max-w-2xl">Locally based, locally focused — covering both sides of the border. Not sure if your address falls in our service area? Give us a call.</p>
        </div>
      </section>
      <section data-nav-theme="light" className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {locations.map((l) => (
            <div key={l} className="bg-white border border-slate-200 p-5 rounded-sm flex items-center gap-2">
              <MapPin size={16} weight="fill" className="text-navy"/>
              <span className="font-medium text-navy">{l}</span>
            </div>
          ))}
        </div>
        <div className="mt-12 text-center">
          <Link to="/quote"><Button className="pill-navy">Get a free quote <ArrowRight size={16} className="ml-2"/></Button></Link>
        </div>
      </section>
    </div>
  );
}
